import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Services } from './pages/Services';
import { Insights } from './pages/Insights';
import { InsightDetail } from './pages/InsightDetail';
import { Contact } from './pages/Contact';
import { Privacy } from './pages/Privacy';
import { Terms } from './pages/Terms';
// Scroll to top on route change
const ScrollToTop = () => {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen bg-brand-warm-white font-sans text-brand-charcoal selection:bg-brand-gold selection:text-white" data-id="element-2">
        <Navbar data-id="element-3" />
        <Routes data-id="element-4">
          <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
          <Route path="/about" element={<About data-id="element-8" />} data-id="element-7" />
          <Route path="/services" element={<Services data-id="element-10" />} data-id="element-9" />
          <Route path="/insights" element={<Insights data-id="element-12" />} data-id="element-11" />
          <Route path="/insights/:slug" element={<InsightDetail data-id="element-14" />} data-id="element-13" />
          <Route path="/contact" element={<Contact data-id="element-16" />} data-id="element-15" />
          <Route path="/privacy" element={<Privacy data-id="element-18" />} data-id="element-17" />
          <Route path="/terms" element={<Terms data-id="element-20" />} data-id="element-19" />
        </Routes>
        <Footer data-id="element-21" />
      </div>
    </BrowserRouter>;
}